import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
// import eventBus  from    '@/plugins/eventBus'

const Methods = {

    data() {
        return {
            notyf,
        }
    },

    watch: {
        form_data: {
            handler(val)
            {
                let keys = Object.keys(val);
                keys.forEach(item => 
                {
                    this.$refs.main_table.params[item] = val[item]
                });

                this.$refs.main_table.params['page'] = 1;
                // this.fetchMainList(this.$refs.main_table.params)
                // eventBus.$emit('hideToast', true)
            },
            deep: true
         },

        async 'form_data.building_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:             val,
                    type_request:   'building',
                }

                const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    if(response.data.length)
                    {
                        setTimeout(() => {
                            this.array_options['level_id'] = response.data 
                        }, 300);
                        notyf.success('Levels available for the selected building')
                    }
                    else
                    {
                        this.array_options['level_id'] = []
                        notyf.error('No levels available for the selected building')
                    }

                    if(!this.first_time_flags['building_id'])
                    {
                        this.form_data.level_id = ''
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                    }
                    else
                    {
                        this.first_time_flags['building_id'] = false
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.array_options['level_id'] = []
                this.form_data.level_id = ''
            }
        },

        async 'form_data.level_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:             val,
                    type_request:   'level',
                }
                const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    if(response.data.length)
                    {
                        setTimeout(() => {
                            this.array_options['area_id'] = response.data
                        }, 300);
                        notyf.success('Areas available for the selected level')
                    }
                    else
                    {
                        this.array_options['area_id'] = []
                        notyf.error('No areas available for the selected level')
                    }

                    if(!this.first_time_flags['level_id'])
                    {
                        this.form_data.area_id = ''
                    }
                    else
                    {
                        this.first_time_flags['level_id'] = false
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.array_options['area_id'] = []
                this.form_data.area_id = ''
            }
        },
        
        async 'form_data.radio'(val)
        {
            if(!this.first_time_flags['task_id'])
            {
                this.form_data.task_id = ''
                this.form_data.frequency = ''
            }
            else
            {
                this.first_time_flags['task_id'] = false
            }

            this.array_options['task_id'] = this.tasks.filter(item => 
            {
                if(val == 'projects')
                {
                    return (item.project === true && item.policing === false)
                }
                else if(val == 'daily')
                {
                    return (item.project === false && item.policing === false)

                }
                else if(val == 'policing')
                {
                    return (item.project === false && item.policing === true)
                }
                else
                {
                    return item
                }
            })
        },
    },


    methods: {
       
       
        returnedRoomsToParent(withoutChecking = false)
        {
            console.log(withoutChecking)
            if(this.use_parent)
            {
                if(this.parent_rooms.length)
                {
                    return {...this.$refs.main_table.returnSelection(), params: this.$refs.main_table.params}
                }
            }
            else
            {
                if(this.rooms.length)
                {
                    return {...this.$refs.main_table.returnSelection(), params: this.$refs.main_table.params}
                }
            }
            return null
        },

        selectAllBoxes()
        {
            if(this.rooms.length)
            {
                this.rooms.map((item) => {
                    item.checked = this.selectAll
                })
            }
        },

        fill_data(data)
        {
            this.$emit('passInitialData', data)

            this.tasks = data.tasks

            this.array_options = {
                building_id:    data.buildings,
                level_id:       this.array_options['level_id'] ?  this.array_options['level_id'] : [],
                area_id:        this.array_options['area_id']  ?  this.array_options['area_id'] : [],
                task_id:        data.tasks,
                room_type_id:   data.room_types,
                floor_id:       data.floors,
                cost_center_id: data.cost_centers,
                group_id:       data.groups,
                frequency_id:   data.frequencies || [],
                daily_assignment_id: data.daily_assignments
            }
        },
        resetList()
        {
            this.$refs.main_table.params['page'] = 1;
            this.fetchMainList(this.$refs.main_table.params)
        },

        async firstRequestWithParams()
        {
            const query_params = this.$route.query
            const query_filters = Object.keys(query_params).map(key => ({ key, value: query_params[key] }))
            
            if(query_filters && query_filters.length)
            {
                let form_data = {...this.form_data}

                query_filters.forEach(element => 
                {
                    form_data[element.key] = element.value
                    this.first_time_flags[element.key] = element.value
                })

                this.form_data = form_data

                // Remove the query params from the URL
                this.$router.replace({ query: null });

                setTimeout(() => {
                    this.resetList()
                }, 100)
            }
        },

    },

}

export default Methods